import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import RightSection from './RightSection';

const LandingPage = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: '#ffffff',
      }}
    >
      {/* Background Section (Car Image) */}
      <RightSection />

      {/* Navbar overlay */}
      <Navbar />

      {/* Main Unified Hero Content */}
      <HeroSection />
    </Box>
  );
};

export default LandingPage;
